define((require) => {
    "use strict";

    var Marionette              = require("marionette"),
        Browser                 = require("shared/services/Browser"),
        PreviewExperienceViewer = require("ui/editor/PreviewExperienceViewer"),
        NotificationBar         = require("editor/ui/notificationbar/NotificationBar"),
        ExperienceCncViewer     = require("ui/viewer/cnc/ExperienceCncViewer"),
        LoggedInUserState       = require("shared/ui/user/LoggedInUserState"),
        template                = require("ui/viewer/ExperiencePreview.tpl");

    /**
     * Experience preview page.
     *
     * <p>Shows an experience viewer centered on the screen.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class ExperiencePreview
     * @constructor
     *
     * @cfg {ExperienceViewModel|TemplateViewModel} experienceViewModel or templateViewModel model to show.
     */
    return Marionette.Layout.extend({

        template: template,

        _zoomModel: null,

        regions: {
            innerContainer: ".preview-inner-container"
        },

        ui: {
            container: ".preview-inner-container",
            outerContainer: ".preview-outer-container"
        },

        _setZoom: function() {
            var scaledWidth = this.options.experienceViewModel.get("experience").get("width") * this._zoomModel.get("scale"),
                viewportWidth = this.ui.outerContainer.width(),
                widthLargerThanViewport = scaledWidth > viewportWidth;

            // We need to transform the origin to avoid having parts of the experience outside the scrollable viewport.
            this.ui.container.toggleClass("origin-left", widthLargerThanViewport);

            this.ui.container.css("transform", "scale(" + this._zoomModel.get("scale") + ")");
        },

        initialize: function() {
            this._zoomModel = this.options.zoomModel;
        },

        onRender: function() {
            // Tag all notifications with this view while in preview mode, so we can discard them again once
            // we leave the preview. We want to ensure that errors, for example a user clicking on a link in
            // the experience with Javascript, will not remain once we leave the preview...
            NotificationBar.tag(this);

            if (Browser.type.webkit) {
                this.$el.addClass("chrome");
            }

            this.listenTo(this._zoomModel, "change:scale", this._setZoom);

            // Change dimension to match experience size
            this.ui.container.height(this.options.experienceViewModel.get("experience").get("height"));
            this.ui.container.width(this.options.experienceViewModel.get("experience").get("width"));
        },

        onShow: function() {
            let viewer;
            const integrations = LoggedInUserState.get("integrations");
            if (integrations.isNativeContentIntegrationsEnabled()) {
                viewer = new ExperienceCncViewer({
                    model: this.options.experienceViewModel,
                    groupsDisable: true
                });
            } else {
                viewer = new PreviewExperienceViewer({
                    model: this.options.experienceViewModel,
                    embedContainer: this.ui.container,
                    scrollableContainer: this.ui.outerContainer,
                    zoomModel: this._zoomModel
                });
            }
            this.innerContainer.show(viewer);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/viewer/ExperiencePreview.js